import { useEffect, useState } from "react";
import TopBar from "../components/TopBar";
import Header from "../components/Header";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Outlet, useLocation } from "react-router-dom";
import { getPosts } from "../utils/networkApi";
import Translate from "../components/Translate";

import { useTranslation } from "react-i18next";

const Layout = () => {
  const { i18n } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [header, setData] = useState([]);
  const [footer, setFooter] = useState([]);
  const location = useLocation();

  useEffect(() => {
    document.documentElement.lang = i18n.language || "en";
  }, [i18n.language]);

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        const savedLang = await localStorage.getItem("appLang") || "en";
        const response = await getPosts(`header-api?lang=${savedLang}`)
        console.log(response)
        setData(response.data)
        setFooter(response.footerData)
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error('Error fetching data:', error);
      }
    }
    fetchData();
  }, [])
  const handleSkipToMain = (e) => {
    if (e) e.preventDefault();
    const banner = document.getElementById("page-banner");
    const mainContent = document.getElementById("main-content");

    let target = mainContent;
    // On inner pages, try to skip the banner if it exists
    if (banner && banner.nextElementSibling) {
      target = banner.nextElementSibling;
    }

    if (target) {
      target.setAttribute("tabindex", "-1");
      // Ensure the target has a scroll-margin-top so it lands below the sticky header
      // We use a custom style if not already present, or just trust the parent's scroll-mt if it's the mainContent
      if (target !== mainContent) {
        target.style.scrollMarginTop = "210px";
      }

      setTimeout(() => {
        target.focus();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 10);
    }
    window.history.pushState(null, null, "#main-content");
  };

  return (
    <div 
      className="App min-h-screen flex flex-col relative"
      data-print-url={window.location.href}
      data-print-date={new Date().toLocaleDateString()}
    >
      <a
        href="#main-content"
        onClick={handleSkipToMain}
        className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:px-4 focus:py-2 focus:bg-primary-700 focus:text-white focus:z-[100] focus:rounded focus:outline-none focus:ring-2 focus:ring-white font-medium text-[14px]"
      >
        <Translate text="skip-to-main-content" />
      </a>
      <div className="sticky top-0 z-50 bg-white shadow">
        <TopBar data={header} onSkipToMain={handleSkipToMain} />
        <Header data={header} />
        <Navbar data={header} />
      </div>
      <main id="main-content" className="flex-1 focus:outline-none scroll-mt-[210px] outline-none" tabIndex="-1">
        <Outlet />
      </main>
      {!loading && <Footer data={footer} />}
    </div>
  )
};

export default Layout;
